import { createActions } from 'reduxsauce';
import type {
  PhysicalDocksBulkDeletePayload,
  PhysicalDocksBulkDeleteResult,
} from 'contracts/PhysicalDocks';

const { Types, Creators } = createActions(
  {
    deleteRequest: ['payload', 'onSuccess', 'onFailure'],
  },
  { prefix: 'BULK_DELETE_PHYSICAL_DOCKS_' }
);

export interface BulkDeletePhysicalDocksDeleteAction {
  payload: PhysicalDocksBulkDeletePayload;
  onSuccess?: (result: PhysicalDocksBulkDeleteResult) => void;
  onFailure?: () => void;
}

export const BulkDeletePhysicalDocksTypes = Types;
export const BulkDeletePhysicalDocksActions = Creators;
